export default __webpack_public_path__ + "static/media/320x180.3a771263.jpg";